import { ThumbsUp, ThumbsDown, RefreshCw, CheckCircle2 } from "lucide-react";
import { imageUrl } from "@/lib/api";
import { IDS } from "@/constants/testIds";

export default function OutfitCard({
  suggestion,
  items,
  weather,
  onAnother,
  onWore,
  onThumb,
  loadingAnother,
  loadingWore,
  feedbackGiven,
}) {
  return (
    <div
      data-testid={IDS.outfitCard}
      className="bg-white rounded-3xl overflow-hidden border border-stone-100 shadow-[0_16px_40px_rgba(28,25,23,0.08)]"
    >
      <div className="grid grid-cols-2 gap-[2px] bg-stone-100">
        {items.map((it) => (
          <div key={it.item_id} className="aspect-[3/4] bg-white overflow-hidden">
            <img
              src={imageUrl(it.storage_path)}
              alt={it.category}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      <div className="p-6 flex flex-col gap-4">
        <div>
          <div className="text-[10px] font-[Manrope] font-bold tracking-[0.25em] uppercase text-[#6B7A54]">
            Today · {suggestion.occasion}
          </div>
          <p
            data-testid={IDS.outfitWhy}
            className="mt-3 font-[Cormorant_Garamond] text-xl leading-snug text-stone-900 italic"
          >
            “{suggestion.why}”
          </p>
          {weather && (
            <div className="mt-3 text-xs font-[Manrope] text-stone-500">
              {suggestion.weather_summary || `${weather.summary}, ${Math.round(weather.temp_c)}°C`}
            </div>
          )}
        </div>

        <div className="flex items-center gap-2 pt-2">
          <button
            data-testid={IDS.outfitThumbUp}
            onClick={() => onThumb("up")}
            disabled={feedbackGiven === "up"}
            className={`h-11 w-11 rounded-full border border-stone-200 flex items-center justify-center transition-colors ${
              feedbackGiven === "up" ? "bg-[#6B7A54] text-white border-transparent" : "text-stone-700 hover:bg-stone-50"
            }`}
          >
            <ThumbsUp size={16} strokeWidth={1.5} />
          </button>
          <button
            data-testid={IDS.outfitThumbDown}
            onClick={() => onThumb("down")}
            disabled={feedbackGiven === "down"}
            className={`h-11 w-11 rounded-full border border-stone-200 flex items-center justify-center transition-colors ${
              feedbackGiven === "down" ? "bg-stone-900 text-white border-transparent" : "text-stone-700 hover:bg-stone-50"
            }`}
          >
            <ThumbsDown size={16} strokeWidth={1.5} />
          </button>
          <div className="flex-1" />
          <button
            data-testid={IDS.outfitAnother}
            onClick={onAnother}
            disabled={loadingAnother}
            className="h-11 px-5 rounded-full border border-stone-300 text-stone-800 font-[Manrope] font-medium text-sm flex items-center gap-2 hover:bg-stone-50 transition-colors disabled:opacity-50"
          >
            <RefreshCw size={14} strokeWidth={1.5} className={loadingAnother ? "animate-spin" : ""} />
            Another
          </button>
        </div>

        <button
          data-testid={IDS.outfitWore}
          onClick={onWore}
          disabled={loadingWore}
          className="w-full bg-stone-900 hover:bg-black text-white rounded-full py-4 font-[Manrope] font-medium tracking-wide flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
        >
          <CheckCircle2 size={16} strokeWidth={1.5} />
          I&rsquo;m wearing this
        </button>
      </div>
    </div>
  );
}
